<section id="awards" class="section" appReveal>
  <p class="eyebrow mb-2">Credentials</p>
  <div class="mb-8 flex flex-wrap items-end justify-between gap-4">
    <h2 class="section-title">Certifications</h2>
    <input
      type="text"
      [(ngModel)]="filteredCategory"
      placeholder="Filter by name…"
      class="input max-w-xs"
    />
  </div>

  <div class="grid gap-4 sm:grid-cols-2">
    <a
      *ngFor="let award of awards | filter:filteredCategory:'name'"
      [href]="award.url"
      target="_blank"
      rel="noopener noreferrer"
      class="card group flex flex-col gap-3"
      [title]="award.name + ': click to verify'"
    >
      <div class="flex items-start justify-between gap-3">
        <span
          class="grid h-10 w-10 shrink-0 place-items-center rounded-lg bg-cyan-500/10 text-cyan-600 dark:text-cyan-400"
        >
          <i class="fas fa-certificate"></i>
        </span>
        <span class="text-xs text-slate-400">{{ award.date | date:'MMM y' }}</span>
      </div>

      <h3 class="font-semibold leading-snug text-slate-900 group-hover:text-cyan-600 dark:text-slate-100 dark:group-hover:text-cyan-400">
        {{ award.name | shorten:90 }}
      </h3>

      <div class="mt-auto flex flex-wrap items-center gap-2 text-sm text-slate-500 dark:text-slate-400">
        <span>{{ award.authority }}</span>
        <span *ngIf="award.category" class="chip text-xs">{{ award.category }}</span>
      </div>
    </a>
  </div>
</section>
